import React, { FormEventHandler, ReactElement } from "react";
import QRCode from "react-qr-code";
import Button from "../../Button/Button";
import loginLogo from "../Login/loginLogo.png";
import Text from "../../Text/Text";
import Icon from "../../Icon/Icon";
import styles from "./MFASetup.module.css";

interface VerifyLoginProps {
  logoStyle?: React.CSSProperties;
  headerStyle?: React.CSSProperties;
  signInButtonStyle?: React.CSSProperties;
  secretCode: string;
  setupComplete: FormEventHandler<HTMLFormElement>;
  close: Function;
}

const MFASetup: React.FC<VerifyLoginProps> = ({
  logoStyle = {},
  headerStyle = {},
  signInButtonStyle = {},
  secretCode,
  setupComplete,
  close,
}): ReactElement => {
  return (
    <div className={styles.login_panel}>
      <div className={styles.controls}>
        <div
          className={styles.control_buttons}
          onClick={() => {
            close();
          }}
        >
          <Icon name="close" size={32} color="#000000" />
        </div>
      </div>
      <div className={styles.login_form}>
        <div className={styles.login_logo}>
          <img src={loginLogo} alt="Login" style={logoStyle} />
        </div>
        <div className={styles.login_header}>
          <h2 className={styles.login_title} style={headerStyle}>
            Two-Factor Authentication
          </h2>
        </div>
        <form className={styles.form} onSubmit={setupComplete}>
          <div className={styles.form_inputs}>
            <label htmlFor="code">Scan QR Code</label>
            <Text
              type="body"
              size="16px"
              color="#000000"
              style={{ marginBottom: "0.7rem", textAlign: "center" }}
            >
              Scan the QR code below using a supported authenticator app (such as Google
              Authenticator etc).
            </Text>
            <QRCode value={`otpauth://totp/RailAuth?secret=${secretCode}`} size={150} />
            <Text
              type="body"
              size="16px"
              color="#000000"
              style={{ marginTop: "0.5rem", marginBottom: "0.5rem", textAlign: "center" }}
            >
              Can’t scan the QR code? Enter this code into your authenticator app instead
            </Text>
            <div className={styles.secret_code}>{secretCode}</div>
            <div className={styles.form_buttons}>
              <button
                name="copy"
                type="submit"
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(secretCode);
                }}
                className={styles.copy_button}
                style={{
                  color: signInButtonStyle.backgroundColor,
                }}
              >
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={styles.copy_icon}
                >
                  <path
                    d="M11.5 0.5H3.5C3.36739 0.5 3.24021 0.552679 3.14645 0.646447C3.05268 0.740215 3 0.867392 3 1V3.5H0.5C0.367392 3.5 0.240215 3.55268 0.146447 3.64645C0.0526785 3.74021 0 3.86739 0 4V12C0 12.1326 0.0526785 12.2598 0.146447 12.3536C0.240215 12.4473 0.367392 12.5 0.5 12.5H8.5C8.63261 12.5 8.75979 12.4473 8.85355 12.3536C8.94732 12.2598 9 12.1326 9 12V9.5H11.5C11.6326 9.5 11.7598 9.44732 11.8536 9.35355C11.9473 9.25979 12 9.13261 12 9V1C12 0.867392 11.9473 0.740215 11.8536 0.646447C11.7598 0.552679 11.6326 0.5 11.5 0.5ZM8 11.5H1V4.5H8V11.5ZM11 8.5H9V4C9 3.86739 8.94732 3.74021 8.85355 3.64645C8.75979 3.55268 8.63261 3.5 8.5 3.5H4V1.5H11V8.5Z"
                    fill={signInButtonStyle.backgroundColor}
                  />
                </svg>
                Copy
              </button>
            </div>
          </div>
          <div className={styles.form_buttons}>
            <Button
              color="blue"
              text="Enter One-Time Passcode"
              name="submit"
              type="submit"
              style={{
                borderRadius: "20px",
                justifySelf: "center",
                backgroundColor: "#37519D",
                height: "44px",
                width: "230px",
                fontSize: "16px",
                fontWeight: "normal",
                marginTop: "30px",
                marginBottom: "10px",
                ...signInButtonStyle,
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default MFASetup;
